import { createAction, props } from '@ngrx/store';
import { GoogleAuthResult, GoogleBusiness } from '@models/index';
import { NotAuthenticated } from '@reducers/gmb/gmb.reducer';

export const reset = createAction(
  '[GMB] Reset'
)

export const error = createAction(
  '[GMB] Error',
  props<{ message: string, cause?: any }>()
)

export const searchGoogleBusinessesByCurrentUser = createAction(
  '[GMB] Search Google Businesses By Current User'
)

export const searchGoogleBusinessesByCurrentUserSuccess = createAction(
  '[GMB] Search Google Businesses By Current User Success',
  props<{ businesses: GoogleBusiness[] | NotAuthenticated }>()
)

/// @param code Use `null` to initiate the login process i.e. redirect to the login page, otherwise pass in the code provided by the redirect back into the application.
export const authenticateWithGoogle = createAction(
  '[GMB] Authenticate With Google',
  props<{ code: string | null }>()
)

export const refreshBusinesses = createAction(
  '[GMB] Refresh Businesses'
)

// TODO: should this not be exposed as an Action? the underlying logic may only be called internally by effects (so .service.ts suffices?)
//export const authorizeServerUserWithGoogleAuth = createAction(
//  '[GMB] Authorize Server User with Google Auth Result',
//  props<{ auth: GoogleAuth }>()
//)
